import { supabase, isConfigured, storePendingMarketingConsent, checkRateLimits, checkAdminStatus, logEvent } from '@rehub/supabase';

export { supabase, isConfigured, storePendingMarketingConsent, checkRateLimits, checkAdminStatus, logEvent };

// Stripe billing portal (invoices, payment methods, subscriptions). Shared
// across every ReHub app via @rehub/commerce + the single Supabase project.
import { openBillingPortal as openBillingPortalShared } from '@rehub/commerce';
export const openBillingPortal = (returnUrl?: string) =>
  openBillingPortalShared(supabase, returnUrl);
